module.exports = __webpack_public_path__ + "static/media/IMG-6.5b664620.jpg";